import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {

  reflect(event) {
    this.updateElement(event.detail.value);
    dispatchCustomEvent(this.element, "change");
  }

  updateElement(value) {
    this.element.value = value;
    this.setHTMLValue(value);
  }

  // Ensures that the html attribute is equivalent to DOM state for testing.
  setHTMLValue(value) {
    this.element.setAttribute("value", value);
  }
}
